module.exports = __webpack_public_path__ + "img/title-4.f7503ade.png";